import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IDatasource, Query } from 'utility-ts-orm';
import { ResourceCategory } from '../builders/resource_category_builder';

export class ResourceCategoryQuery implements IQuery {
  private _result: ResourceCategory[];

  constructor(private ngResourceCategoryDatastore: IDatasource<ResourceCategory>) {
    Query.registerQuery(this, this.ngResourceCategoryDatastore);
  }

  run(): this {
    this._result = _4.sortBy(this.ngResourceCategoryDatastore.values(), (cat: ResourceCategory) =>
      cat.name.toLowerCase()
    );
    return this;
  }

  get result() {
    return this._result;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-resources/src/queries/resource_category_query.ts